import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import ModalMenu from "./ModalMenu/ModalMenu";
import "./ModalPhoto.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const ModalPhoto = (props) => {
  const [open, setOpen] = React.useState(false);
  const [photosList, setphotolist] = React.useState(props.bien[0].url_photo);
  const [imagePrincipale, setimagePrincipale] = React.useState("");
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        variant="outlined"
        startIcon={<EditIcon />}
        onClick={handleClickOpen}
      >
        Modifier
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"selectionner l'image principale"}</DialogTitle>
        <DialogContent>
          <ModalMenu bien={props.bien} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Appliquer</Button>
          <Button onClick={handleClose}>Annuler</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ModalPhoto;
